import * as Yup from 'yup';

export const TrackPackageSchema = Yup.object().shape({
  trackingId: Yup.string().min(1).required('Please provide tracking id'),
});

export type TrackPackageDataType = Yup.InferType<typeof TrackPackageSchema>;

type InitialValues = {
  trackingId: string;
};

export const trackPackageInitialValues: InitialValues = {
  trackingId: '',
};

export interface ITrackPackageResponse {
  id: string;
  packageId: string;
  name: string;
  description: string;
  paymentStatus: boolean;
  customerName: string;
  customerEmail: string;
  customerPhoneNumber: string;
  status: string;
  weight: number;
  warehouseId?: string | null;
  warehouseArrivalDate?: string | null;
  warehouseDepartureDate?: string | null;
  storedAtWarehouseBy?: string | null;
  paidSpecialFee: boolean;
  specialFee: number;
  deliveryDate?: string | null;
  deliveryCity: string;
  deliveryState: string;
  deliveryAddress: string;
  deliveryZipCode?: string | null;
  deliveredBy?: string | null;
  deliveredByName?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ITrackPackageDataRequest {
  trackingId: string;
}
